import { render } from "./LoanproLogo.vue?vue&type=template&id=02985ed3"
const script = {}

import "./LoanproLogo.vue?vue&type=style&index=0&id=02985ed3&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__